import React from 'react';
import GuideEditorComponent from '../../../components/guide-editor';

const GuideEditor = (props) => (
  <GuideEditorComponent {...props}/>
)

export default GuideEditor;
